/**
 * Diese Komponente bindet dann das jeweilige Modul ein, lädt die Seiten und übergibt den User, sowie die verfügbaren Socialmediakanäle und die jeweiligen Pfade und Token.
 */

import 'regenerator-runtime/runtime'
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { Grid, Theme } from '@mui/material'

import { UserScreen } from '@professocial/professocialTypes/types/commonTypes'

import { getInstagramNumberOfPosts, getTheme, getUser, } from '../../../../store/common/common.selectors'
import { getFacebookPage, getInstagramPage, getLinkedInPage } from '../../../../store/dashboard/dashboard.selector'

import DashboardNetworkContentTabs from '../components/DashboardNetworkContentTabs'
import DashboardNetworkContentProperties from '../components/DashboardNetworkContentProperties'

import { UserSettings } from '@professocialApi/professocial-core-frontend-api'
import { FacebookPage, InstagramPage, LinkedInPage, NetworkType } from '@3m5/sm_publish-frontend-api'

import ImportProfessocialNetworkContent
  from '../../../../shared/components/ImportComponents/ImportProfessocialNetworkContent'
import { NetworkContentConfiguration } from '@professocial/professocialTypes/types/configurationTypes'

const UserDashboardNetworkContent: React.FC = () => {
  const user: UserSettings | undefined = useSelector(getUser)
  const theme: Theme = useSelector(getTheme)

  const instagramNumberOfPosts = useSelector(getInstagramNumberOfPosts)
  const storedFacebookPage: FacebookPage | undefined = useSelector(getFacebookPage)
  const storedInstagramPage: InstagramPage | undefined = useSelector(getInstagramPage)
  const storedLinkedInPage: LinkedInPage | undefined = useSelector(getLinkedInPage)

  const [activeTab, setActiveTab] = React.useState<NetworkType>(NetworkType.Facebook)
  const [networkContentConfiguration, setNetworkContentConfiguration] = React.useState<NetworkContentConfiguration>()

  useEffect(() => {
    setNetworkContentConfiguration({
      networkPage: {
        facebookPage: storedFacebookPage,
        instagramPage: storedInstagramPage,
        linkedInPage: storedLinkedInPage,
      },
      user,
      networkType: activeTab,
      theme,
      generalOptions: { instagramNumberOfPosts: instagramNumberOfPosts },
    })
  }, [storedInstagramPage, storedFacebookPage, user, activeTab, theme, instagramNumberOfPosts])


  return (
    <Grid
      container
      direction='row'
    >
      <Grid container item xs={12}>
        <Grid item xs={12}>
          <DashboardNetworkContentTabs
            activeItem={activeTab}
            tabs={[NetworkType.Facebook, NetworkType.Instagram, NetworkType.GoogleMyBusiness, NetworkType.LinkedIn]}
            screen={UserScreen.dashboard}
            onChangeTab={(tab: NetworkType) => {
              setActiveTab(tab)
            }}
          />
        </Grid>
        <Grid item xs={12}>
          {networkContentConfiguration?.networkPage &&
            <DashboardNetworkContentProperties
              activeTab={activeTab} networkPage={networkContentConfiguration.networkPage}
            />}
        </Grid>
        <Grid item xs={12}>
          <ImportProfessocialNetworkContent networkContentConfiguration={networkContentConfiguration} />
        </Grid>
      </Grid>
    </Grid>
  )
}
export default UserDashboardNetworkContent
